import { routerStyxie } from '@/router/styxieBridge'

Styxie.Initializers.FacebookAccounts = routerStyxie({ actions: ['index']})
